import { createSlice } from '@reduxjs/toolkit';

import { apiHostname } from 'shared/constants';
import { AlphamartHttpError } from 'shared/types';
import {
  GenericStoreReducer,
  GenericStoreSlice,
  GenericThunk,
  getGenericReducers,
} from './shared/createGenericStoreSlice';

const unassignHedgeSlice = createSlice<GenericStoreSlice, GenericStoreReducer<GenericStoreSlice>>({
  name: 'unassignHedge',
  initialState: {
    isPending: false,
  },
  reducers: {
    ...getGenericReducers(),
  },
});

export const {
  pending: unassignHedgeAction,
  success: unassignHedgeSuccessAction,
  failure: unassignHedgeFailureAction,
} = unassignHedgeSlice.actions;

export const unassignHedge =
  (id: number): GenericThunk =>
  async (dispatch, getState, httpClient) => {
    try {
      dispatch(unassignHedgeAction());

      await httpClient.patch(`${apiHostname}/api/hedges/${id}/unassign`);

      return dispatch(unassignHedgeSuccessAction({}));
    } catch (error) {
      dispatch(unassignHedgeFailureAction());

      return Promise.reject((error as AlphamartHttpError)?.response?.data);
    }
  };

export default unassignHedgeSlice.reducer;
